import { Users, DollarSign, Clock, Shield } from "lucide-react";
import { useStaggeredAnimation } from "@/hooks/useScrollAnimation";
const ConsumerBenefits = () => {
  const {
    ref,
    visibleItems
  } = useStaggeredAnimation(4, 150);
  const benefits = [{
    icon: Users,
    title: "Reach Serious Buyers",
    description: "Access to a network of cash buyers and investors ready to close quickly"
  }, {
    icon: DollarSign,
    title: "No Marketing Costs",
    description: "Professional listing, photos, and promotion at zero cost to you"
  }, {
    icon: Clock,
    title: "Fast Closings",
    description: "Connect with buyers who can close quickly, often with cash offers"
  }, {
    icon: Shield,
    title: "Enterprise Grade Security",
    description: "Bank-level encryption and security protocols protect your property information and personal data"
  }];
  return <section ref={ref} className="py-20 px-4 bg-gray-900/30">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4">Why Work With Us?</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Get professional marketing and access to serious buyers without any costs to you!  
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => <div key={index} className={`bg-gray-800 border border-gray-700 rounded-lg p-6 transition-all duration-500 ${visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
              <div className="w-12 h-12 bg-[#ffd700]/10 rounded-lg flex items-center justify-center mb-4">
                <benefit.icon className="h-6 w-6 text-[#ffd700]" />
              </div>
              <h3 className="text-xl font-semibold mb-2">{benefit.title}</h3>
              <p className="text-gray-400">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default ConsumerBenefits;